/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanEntitlementUpdateRequest
 */
export interface PlanEntitlementUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PlanEntitlementUpdateRequest
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof PlanEntitlementUpdateRequest
     */
    quantityLimit?: number | null;
}

/**
 * Check if a given object implements the PlanEntitlementUpdateRequest interface.
 */
export function instanceOfPlanEntitlementUpdateRequest(value: object): value is PlanEntitlementUpdateRequest {
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function PlanEntitlementUpdateRequestFromJSON(json: any): PlanEntitlementUpdateRequest {
    return PlanEntitlementUpdateRequestFromJSONTyped(json, false);
}

export function PlanEntitlementUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanEntitlementUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'quantityLimit': json['quantityLimit'] == null ? undefined : json['quantityLimit'],
    };
}

export function PlanEntitlementUpdateRequestToJSON(json: any): PlanEntitlementUpdateRequest {
    return PlanEntitlementUpdateRequestToJSONTyped(json, false);
}

export function PlanEntitlementUpdateRequestToJSONTyped(value?: PlanEntitlementUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'quantityLimit': value['quantityLimit'],
    };
}

